import React, { useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box } from "@mui/material";
import { InputText } from "../../uiControls/inputText";
import { InputDateTime } from "../../uiControls/inputDateTime";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { MessageDisplay } from "../../common/messageDisplay";
import { SaveCancel } from "../../uiControls/saveCancel";
import * as utils from "../../common/utils";

const initialDstYearIsValid = {
  year: "",
  startDate: "",
  endDate: "",
};

export const DstYearUpdate = (props) => {
  const { setUpdateOpen, dstYearEdit, setDstYearEdit, dstYearAttributes } =
    props;
  const messageDispatch = useDispatch();
  const { sendRequest: updateDstYear } = useHttpRequests();

  const [dstYearDetails, setDstYearDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    dstYearAttributes
  );

  const [isValid, setIsValid] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialDstYearIsValid
  );

  const updateDstYearDetailsValue = (_key, value) => {
    setDstYearDetails({ [_key]: value });
    if (value) {
      updateErrorMessage([_key], "", "");
    }
  };

  const updateErrorMessage = (_key, header, errMsg) => {
    setIsValid({ [_key]: errMsg + header });
  };

  const onChangeHandler = (e, controlName) => {
    updateDstYearDetailsValue(
      controlName,
      e.target.type === "checkbox" ? e.target.checked : e.target.value
    );
  };

  const onDateChangeHandler = (e, controlName) => {
    if (isNaN(e)) {
      messageDispatch(
        setMessageHandler({
          type: "error",
          message:
            "Invalid " +
            (controlName === "startDate" ? "Start Date" : " End Date."),
        })
      );
      updateDstYearDetailsValue(controlName, null);
    } else {
      updateDstYearDetailsValue(controlName, e?.toISOString());
    }
  };

  const cancelDstYearHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setDstYearEdit(false);
    setUpdateOpen(false);
  };

  const validateDstYearDetails = () => {
    setIsValid(initialDstYearIsValid);

    var errorSummary = "";

    if (!dstYearDetails.year) {
      updateErrorMessage("year", "Dst Year", "Enter ");
      errorSummary += "Enter dst Year \n";
    }

    if (!dstYearDetails.startDate) {
      updateErrorMessage("startDate", "Start Date", "Enter ");
      errorSummary += "Enter start date \n";
    }

    if (!dstYearDetails.endDate) {
      updateErrorMessage("endDate", "End Date", "Enter ");
      errorSummary += "Enter end date \n";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({ type: "error", message: errorSummary })
      );
    } else {
      const myStartDate = utils.getDateString(dstYearDetails.startDate);
      const myEndDate = utils.getDateString(dstYearDetails.endDate);

      dstYearDetails["startDate"] = myStartDate;
      dstYearDetails["endDate"] = myEndDate;

      const dataObj = dstYearDetails;

      const getUpdateDstYearResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          (resObj["validationErrors"] !== undefined &&
            resObj["validationErrors"]?.length > 0)
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "Dst Year updated successfully!",
          })
        );
        setTimeout(() => {
          cancelDstYearHandler();
        }, 2000);
      };

      if (dstYearEdit) {
        updateDstYear(
          {
            url: "DstYears/" + dataObj["yearKey"],
            method: "PUT",
            body: dataObj,
          },
          getUpdateDstYearResponse
        );
      } else {
        delete dataObj["yearKey"];
        updateDstYear(
          { url: "DstYears", body: dataObj },
          getUpdateDstYearResponse
        );
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "hidden",
          padding: "0px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <MessageDisplay />
          <InputText
            type="number"
            label="Dst Year"
            id={"dstYearDetails.year"}
            value={dstYearDetails.year}
            onChange={(e) => onChangeHandler(e, "year")}
            isRequired={true}
            isError={isValid["year"] !== ""}
            charLength={4}
          />

          <InputDateTime
            type="date"
            label="Dst Year Start"
            id={"dstYearDetails.startDate"}
            value={dstYearDetails.startDate}
            onChange={(e) => onDateChangeHandler(e, "startDate")}
            isRequired={true}
            isError={isValid["startDate"] !== ""}
          />

          <InputDateTime
            label="Dst Year End"
            id={"dstYearDetails.endDate"}
            value={dstYearDetails.endDate}
            onChange={(e) => onDateChangeHandler(e, "endDate")}
            isRequired={true}
            isError={isValid["endDate"] !== ""}
          />
          <SaveCancel
            cancelCall={() => cancelDstYearHandler()}
            saveCall={() => validateDstYearDetails()}
          />
        </div>
      </Box>
    </>
  );
};
